export var Paths;

(function (Paths) {
  Paths["List"] = "/series";
  Paths["Show"] = "/series/:seriesSlug";
  Paths["ListVideos"] = "/series/:seriesSlug/videos";
  Paths["FindVideoIndex"] = "/series/:seriesSlug/videos_index";
  Paths["ListSeasons"] = "/series/:seriesSlug/seasons";
  Paths["ShowSeason"] = "/series/:seriesSlug/seasons/:seasonSlug";
  Paths["ListSeasonVideos"] = "/series/:seriesSlug/seasons/:seasonSlug/videos";
  Paths["FindSeasonVideoIndex"] = "/series/:seriesSlug/seasons/:seasonSlug/videos_index";
})(Paths || (Paths = {}));